import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/subtopic4/boxPar.glb";
import { GUI } from "dat.gui";

export class BoxPAR extends Mesh {
	constructor(camera, loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);

		let dracoloader = new DRACOLoader();
		this.camera = camera;
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		// this.helpers();
		this.observerListtneners();
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.box_celular = gltf.scene.getObjectByName("box_celular", true);
			this.box_cigarros = gltf.scene.getObjectByName("box_cigarros", true);
			this.box_alchol = gltf.scene.getObjectByName("box_alchol", true);
			this.box_dinero = gltf.scene.getObjectByName("box_dinero", true);
			this.box_celular.material.transparent = true;
			this.box_celular.material.opacity = 0.01;
			this.box_cigarros.material.transparent = true;
			this.box_cigarros.material.opacity = 0.01;
			this.box_alchol.material.transparent = true;
			this.box_alchol.material.opacity = 0.01;
			this.box_dinero.material.transparent = true;
			this.box_dinero.material.opacity = 0.01;
		});
	}

	observerListtneners() { }

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("boxpar");
		premiaFolder.add(this.position, "x", -10, 10).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -10, 10).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -10, 10).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		// premiaFolder.open();
	}

	renderAnimations() { }
}
